import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconChevronRight } from '@travel-frontend/icons';
import { memo } from 'react';
import { IconButton } from '../../../../components/internal/DateRangePicker/components/IconButton.js';
export const NextButton = memo(props => _jsx(IconButton, {
  ...props,
  category: "secondary",
  round: true,
  children: _jsx(IconChevronRight, {
    fontScale: "large"
  })
}));